<template>
  <v-row style="padding: 0px 20px">
    <v-col cols="4">
      <v-text-field
        label="Modelo del Celular"
        v-model="modelo"
        :rules="inputsRequeridos"
        @change="avisarCambio"
      ></v-text-field>
    </v-col>
    <v-col cols="4">
      <v-text-field
        label="Costo del Celular (Valor Factura)"
        v-model="precio_factura"
        :rules="inputsRequeridos"
        @change="avisarCambio"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data () {
    return {
      modelo: null,
      precio_factura: null,
      
      //Validadores
      inputsRequeridos: [
        value => !!value || 'Campo Requerido',
      ],
    }
  },
  props: ['avisar', 'infoEmision'],
  methods: {
    avisarCambio(){
      let datos = {
        modelo: this.modelo,
        precio_factura: this.precio_factura,
      }
      this.avisar(datos)
    }
  },
  mounted() {
    this.modelo = this.infoEmision.modelo
    this.precio_factura = this.infoEmision.precio_factura
  }
}
</script>